export default {"src":"/_next/static/media/MSFT.d4d28920.svg","height":18,"width":18};